// extracted by mini-css-extract-plugin
export default {"list-wrap":"DLOFI_list-wrap"};